import { Component, HostListener, ViewEncapsulation } from '@angular/core';
import { NavigationStart, Router, RouterEvent } from '@angular/router';
import { AuthApiService } from './shared/core-rms/auth.service';
import { BackProcessorService } from 'projects/shared/core/services/back-processor.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  private authorized: boolean = false;

  title = 'RMS';
  toastOptions = {
    position: ["top", "right"],
    timeOut: 5000,
    lastOnBottom: true
  }

  constructor(
    private authApiService: AuthApiService,
    private router: Router,
    private backProcessor: BackProcessorService) {
    backProcessor.addListener();
    this.router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationStart) {
        this.authApiService.setRedirectUrl(event.url);
      }
    });
  }

  @HostListener('window:popstate', ['$event'])

  onPopState(event) {
    console.log('Back button pressed', event.state);
  }

}
